export default "__VITE_ASSET__BU$UKF6L__"